import * as React from "react";
import { ScrollView } from "react-native";
import { Block } from "@block";
import HeaderNav from "app/shared/components/header-nav/header-nav";
import { StackActions, useNavigation } from "@react-navigation/native";
import { spacing } from "@styles/spacing";
import { useDesktopMediaQuery } from "app/shared/util/media-query";
import { StackSpacing } from "@components/spacing";
import { useTranslation } from "react-i18next";
import { StepProcessUniversal } from "app/shared/components/stepper-process/stepper-process";
import { NavTitleBar, SubtitleNavTitleBar } from "app/shared/components/nav-title-bar/nav-title-bar";
import { ButtonFormActions, ButtonRow, HeaderSuccessTitleNone, RowInputColumn } from "app/shared/components/screen-success/screen-success";
import { useSelector } from "react-redux";
import { getAutoBillingStoreSelector } from "../reducer/selectors";
import ScreenNameType from "@navigation/nav-screens";
import GlobalViewShot, { GlobalViewShotRef } from "app/shared/components/global-view-shot/global-viewshot.web";
import { getContactIdSelector } from "app/modules/account-management/reducer/selectors";
import { pushCleverTapEvent } from "app/shared/util/app-flyer";
import moment from "moment";

const AutoBillingsSuccess = () => {
  const { dispatch } = useNavigation();
  const { t } = useTranslation();
  const isDesktop = useDesktopMediaQuery();
  const globalViewShotRef = React.useRef<GlobalViewShotRef>(null);
  const autoBillingStore = useSelector(getAutoBillingStoreSelector);
  const contactId = useSelector(getContactIdSelector);

  const onPressGoHome = () => {
    eventPushCleverTap(undefined, undefined, "trang_chu");
    dispatch(StackActions.replace(ScreenNameType.HOME));
  };

  const onPressGoBack = () => {
    eventPushCleverTap(undefined, undefined, "giao_dich_khac");
    dispatch(StackActions.replace(ScreenNameType.LIST_PAYMENTS));
  };

  const subtitlesArrays: Array<SubtitleNavTitleBar> = [
    {
      name: t("FUNC_TRANG_CHU"),
      onPressSubtitle: () => onPressGoHome(),
    },
    {
      name: t("FUNC_DV_THANH_TOAN"),
      onPressSubtitle: () => onPressGoBack(),
    },
    {
      name: t("AUTO_BILLING_DANG_KY_THANH_TOAN_HOA_DON_TU_DONG"),
      onPressSubtitle: () => {},
    },
  ];

  const onPressPrint = () => {
    eventPushCleverTap(undefined, undefined, "in_bien_lai");
    globalViewShotRef.current?.printViewShot();
  };

  const onPressShare = () => {
    eventPushCleverTap(undefined, undefined, "tai_ve");
    globalViewShotRef.current?.takeViewShot();
  };

  const eventPushCleverTap = (status?: boolean, response?: string, action?: string) => {
    const { eventNameCT, paramsCT } = handlerParamsCleverTap(status, response, action);
    pushCleverTapEvent(eventNameCT, paramsCT);
  };

  const handlerParamsCleverTap = (status?: boolean, response?: string, action?: string) => {
    console.log("handlerParamsCleverTap");
    let param = {};
    param = {
      ct_channel: "ib_rb",
      ct_cccd_ID: contactId,
      ct_billing_type: "auto_billing", //top_up | billing_payment | auto_topup | auto_billing
      ct_billing_service: autoBillingStore.dataCreate?.SERVICE?.label,
      ct_billing_provider: autoBillingStore.dataCreate?.PROVIDER?.label,
      ct_billing_phone: autoBillingStore.dataCreate?.INQUIRY_CODE,
      ct_billing_amount: "",
      ct_billing_fee: "",
      ct_transaction_session: autoBillingStore?.responseCreate?.transId,
      ct_button: action || "", // in_bien_lai | tai_ve | trang_chu | giao_dich_khac
      ct_transaction_time: moment().format("YYYY-MM-DD HH-mm-ss"),
      ct_error_message: status === false ? response || "" : "",
    };
    if (status !== undefined) {
      param = {
        ...param,
        ct_transfer_success_status: status ? "success" : "failure",
      };
    }

    return {
      eventNameCT: "ct_billing_success",
      paramsCT: param,
    };
  };

  const FormSuccess = (
    <Block center p={spacing.large}>
      <RowInputColumn name={t("BILLING_DICH_VU")} value={autoBillingStore.dataCreate?.SERVICE?.label} />
      <RowInputColumn name={t("BILLING_NHA_CUNG_CAP")} value={autoBillingStore.dataCreate?.PROVIDER?.label} />
      <RowInputColumn name={t("BILLING_MA_HOA_DON_KHACH_HANG")} value={autoBillingStore.dataCreate?.INQUIRY_CODE} />
      <RowInputColumn name={t("AUTO_BILLING_GHI_CHU")} value={autoBillingStore.dataCreate?.NOTE} />
      <RowInputColumn name={t("COMMON_MA_GD")} value={autoBillingStore?.responseCreate?.transId} />
    </Block>
  );

  React.useEffect(() => {
    eventPushCleverTap(true);
  }, []);

  return (
    <Block flex={1}>
      <ScrollView>
        <HeaderNav />
        <NavTitleBar title={t("AUTO_BILLING_DANG_KY_THANH_TOAN_HOA_DON_TU_DONG")} subtitles={subtitlesArrays} />
        <Block pv={spacing.huge} ph={isDesktop ? 150 : 0}>
          <StepProcessUniversal currentSteps={3} />
          <StackSpacing size="medium" />
          <GlobalViewShot ref={globalViewShotRef}>
            <HeaderSuccessTitleNone headlineText={t("COMMON_DANG_KY_THANH_CONG")} />
            {FormSuccess}
          </GlobalViewShot>
          <ButtonFormActions onPressPrint={onPressPrint} onPressShare={onPressShare} />
          <ButtonRow onPressGoBack={onPressGoBack} onPressGoHome={onPressGoHome} />
        </Block>
      </ScrollView>
    </Block>
  );
};

export default AutoBillingsSuccess;
